type NodeOptions = {
  coords?: number[];
};

export default class Node {
  value: string;
  coords: number[];

  constructor(value: string, { coords }: NodeOptions) {
    this.value = value;
    this.coords = coords || [0, 0];
  }
}
